/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Referral_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "Create your first code to start sharing referral links." |
*
* @param {Partner_Referral_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_empty_body = /** @type {((inputs?: Partner_Referral_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie Ihren ersten Code, um Empfehlungslinks zu teilen.")
	return /** @type {LocalizedString} */ ("Create your first code to start sharing referral links.")
});